export const localesAvailable = {
  "en-US": "English",
  "es-ES": "Español",
  ca: "Català",
  "sv-SE": "Svenska",
  sw: "Kiswahili",
};
